var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "g",
    { staticClass: "Highlight", attrs: { "aria-selected": _vm.selected } },
    [
      _c("rect", {
        staticClass: "Highlight _fill",
        attrs: { x: _vm.x, y: _vm.y, width: _vm.w, height: _vm.h }
      }),
      _vm._v(" "),
      _c("rect", {
        staticClass: "Highlight _outline",
        attrs: {
          x: _vm.x - 2,
          y: _vm.y - 2,
          width: _vm.w + 4,
          height: _vm.h + 4
        }
      }),
      _vm._v(" "),
      _c(
        "text",
        {
          staticClass: "Highlight _label",
          attrs: { x: _vm.x + 2, y: _vm.y - 2, dy: _vm.h - 2 }
        },
        [_vm._v("\n    " + _vm._s(_vm.order + 1) + "\n  ")]
      ),
      _vm._v(" "),
      _c("rect", {
        ref: "c",
        staticClass: "Highlight _clickableArea",
        attrs: { x: _vm.x, y: _vm.y, width: _vm.w, height: _vm.h },
        on: {
          mousedown: function($event) {
            _vm.dragStart("c", $event)
          }
        }
      }),
      _vm._v(" "),
      _c("rect", {
        ref: "t",
        staticClass: "Highlight _ctrl _ctrl--t",
        attrs: {
          x: _vm.x - 5 + _vm.w * 0.5,
          y: _vm.y - 5,
          width: 10,
          height: 10
        },
        on: {
          mousedown: function($event) {
            _vm.dragStart("t", $event)
          }
        }
      }),
      _vm._v(" "),
      _c("rect", {
        ref: "r",
        staticClass: "Highlight _ctrl Highlight _ctrl--r",
        attrs: {
          x: _vm.x - 5 + _vm.w,
          y: _vm.y - 5 + _vm.h * 0.5,
          width: 10,
          height: 10
        },
        on: {
          mousedown: function($event) {
            _vm.dragStart("r", $event)
          }
        }
      }),
      _vm._v(" "),
      _c("rect", {
        ref: "b",
        staticClass: "Highlight _ctrl Highlight _ctrl--b",
        attrs: {
          x: _vm.x - 5 + _vm.w * 0.5,
          y: _vm.y - 5 + _vm.h,
          width: 10,
          height: 10
        },
        on: {
          mousedown: function($event) {
            _vm.dragStart("b", $event)
          }
        }
      }),
      _vm._v(" "),
      _c("rect", {
        ref: "l",
        staticClass: "Highlight _ctrl Highlight _ctrl--l",
        attrs: {
          x: _vm.x - 5,
          y: _vm.y - 5 + _vm.h * 0.5,
          width: 10,
          height: 10
        },
        on: {
          mousedown: function($event) {
            _vm.dragStart("l", $event)
          }
        }
      }),
      _vm._v(" "),
      _c("circle", {
        ref: "tl",
        staticClass: "Highlight _ctrl Highlight _ctrl--tl",
        attrs: { cx: _vm.x, cy: _vm.y, r: 10 },
        on: {
          mousedown: function($event) {
            _vm.dragStart("tl", $event)
          }
        }
      }),
      _vm._v(" "),
      _c("circle", {
        ref: "tr",
        staticClass: "Highlight _ctrl Highlight _ctrl--tr",
        attrs: { cx: _vm.x + _vm.w, cy: _vm.y, r: 10 },
        on: {
          mousedown: function($event) {
            _vm.dragStart("tr", $event)
          }
        }
      }),
      _vm._v(" "),
      _c("circle", {
        ref: "br",
        staticClass: "Highlight _ctrl Highlight _ctrl--br",
        attrs: { cx: _vm.x + _vm.w, cy: _vm.y + _vm.h, r: 10 },
        on: {
          mousedown: function($event) {
            _vm.dragStart("br", $event)
          }
        }
      }),
      _vm._v(" "),
      _c("circle", {
        ref: "bl",
        staticClass: "Highlight _ctrl Highlight _ctrl--bl",
        attrs: { cx: _vm.x, cy: _vm.y + _vm.h, r: 10 },
        on: {
          mousedown: function($event) {
            _vm.dragStart("bl", $event)
          }
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }